// extracted by mini-css-extract-plugin
module.exports = {"root":"V_bx","full-width":"V_c5","fullWidth":"V_c5"};